import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const markAttendance = async (data) => {
  const res = await axiosInstance.post("/student-attendance-portal/mark", data);
  return res.data;
};

export const editAttendance = async (date, data) => {
  const res = await axiosInstance.put(
    `/student-attendance-portal/edit/${date}`,
    data
  );
  return res.data;
};

export const getMyClassAttendance = async (sectionId, date) => {
  const params = {};
  if (sectionId) params.sectionId = sectionId;
  if (date) params.date = date;

  console.log("=== ATTENDANCE API CALL ===");
  console.log("Base URL:", API);
  console.log("Full path:", API + "/student-attendance-portal/my-class");
  console.log("Params:", params);

  const res = await axiosInstance.get("/student-attendance-portal/my-class", {
    params,
  });
  return res.data;
};
export const getMyClassSummary = async (sectionId, year, month) => {
  const res = await axiosInstance.get(
    "/student-attendance-portal/my-class/summary",
    {
      params: { sectionId, year, month },
    }
  );
  return res.data;
};

export const getAbsentStudentsToday = async () => {
  const res = await axiosInstance.get(
    "/student-attendance-portal/absent-today"
  );
  return res.data;
};

export const getSectionAttendance = async (sectionId, filters = {}) => {
  const res = await axiosInstance.get(
    `/student-attendance-portal/section/${sectionId}`,
    { params: filters }
  );
  return res.data;
};

export const getStudentAttendance = async (studentId, filters = {}) => {
  const res = await axiosInstance.get(
    `/student-attendance-portal/student/${studentId}`,
    { params: filters }
  );
  return res.data;
};

export const adminOverrideAttendance = async (data) => {
  const res = await axiosInstance.post(
    "/student-attendance-portal/override",
    data
  );
  return res.data;
};

export const getAttendanceSummary = async (filters = {}) => {
  const res = await axiosInstance.get("/student-attendance-portal/summary", {
    params: filters,
  });
  return res.data;
};